import {Component, inject, OnInit} from '@angular/core';
import { Router, RouterLink, RouterLinkActive, NavigationEnd } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../core/services/sidebar/sidebar.service';
import { filter } from 'rxjs';
import {AuthService} from '../../core/services/auth/auth.service';
import {TenantLogoService} from '../../core/services/TenantLogoService';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    MatListModule,
    MatIconModule,
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  sidebarService = inject(SidebarService);
  private router = inject(Router);
  hostname = window.location.hostname;
  tenant=  this.hostname.split('.')[0].toLowerCase();
  logoService = inject(TenantLogoService);
  logoPath = this.logoService.logoUrl;
  constructor(public authService: AuthService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (window.innerWidth <= 768) {
          this.sidebarService.close();
        }
      });
  }

  ngOnInit() {
    this.logoService.loadLogo().subscribe();
  }

  closeSidebar() {
    if (window.innerWidth <= 768) {
      this.sidebarService.close();
    }
  }
}
